export const downloadFile = (
  content: string | Blob,
  filename: string,
  mimeType: string = "text/plain"
) => {
  let blob: Blob

  if (typeof content === "string") blob = new Blob([content], { type: mimeType })
  else blob = content

  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const downloadFileFromUrl = async (fileUrl: string, filename: string) => {
  const response = await fetch(fileUrl)
  if (!response.ok) throw new Error(`Can't download file by URL: ${fileUrl}`)

  const blob = await response.blob()
  downloadFile(blob, filename, blob.type)
}
